import {
  FilePreview,
  PaymentFile,
  Providers,
} from "../../interfaces/BulkPayment";

export enum BulkPaymentTypes {
  UPLOAD_FILE = "@@bulk-payment/UPLOAD_FILE",
  FILE_PREVIEW = "@@bulk-payment/FILE_PREVIEW",
  FILE_PREVIEW_REQUEST = "@@bulk-payment/FILE_PREVIEW_REQUEST",
  UPLOAD_FILE_SUCCESS = "@@bulk-payment/FILE_UPLOAD_SUCCESS",
  UPLOAD_FILE_FAILED = "@@bulk-payment/FILE_UPLOAD_FAILED",
  GET_PROVIDERS = "@@bulk-payment/GET_PROVIDERS",
  GET_PROVIDERS_SUCCESS = "@@bulk-payment/GET_PROVIDERS_SUCCESS",
  UPLOAD_FILE_FAILURE = "@@bulk-payment/FILE_UPLOAD_FAILURE",
  INCREASE_BULK_PAYMENT_STEP = "@@bulk-payment/INCREASE_BULK_PAYMENT_STEP",
  INCREASE_BULK_PAYMENT_STEP_CUSTOM = "@@payment/INCREASE_BULK_PAYMENT_STEP_CUSTOM",
  DECREASE_BULK_PAYMENT_STEP = "@@payment/DECREASE_BULK_PAYMENT_STEP",
  BULK_PAYMENT_STEP_CUSTOM = "@@bulk-payment/DECREASE_BULK_PAYMENT_STEP_CUSTOM",
  COMPLETE_PAYMENT_REQUEST = "@@bulk-payment/COMPLETE_PAYMENT_REQUEST",
  COMPLETE_PAYMENT_SUCCESS = "@@bulk-payment/COMPLETE_PAYMENT_SUCCESS",
  COMPLETE_PAYMENT_FAILURE = "@@bulk-payment/COMPLETE_PAYMENT_FAILURE",
  CLEAR_STATES = "@@bulk-payment/CLEAR_STATES",
  GET_BULKPAYMENT_FILES_REQUEST = "@@bulk-payment/GET_BULKPAYMENT_FILES_REQUEST",
  GET_BULKPAYMENT_FILES_SUCESS = "@@bulk-payment/GET_BULKPAYMENT_FILES_SUCESS",
  GET_BULKPAYMENT_FILES_FAILURE = "@@bulk-payment/GET_BULKPAYMENT_FILES_FAILURE",
  SUBMIT_TO_CHECKER_REQUEST = '@bulk-payment/SUBMIT_TO_CHECKER_REQUEST',
  SUBMIT_TO_CHECKER_SUCCESS = '@bulk-payment/SUBMIT_TO_CHECKER_SUCCESS',
  SUBMIT_TO_CHECKER_FAILURE = '@bulk-payment/SUBMIT_TO_CHECKER_FAILURE',
  APPROVE_BULK_PAYMENT_REQUEST = '@bulk-payment/APPROVE_BULK_PAYMENT_REQUEST',
  APPROVE_BULK_PAYMENT_SUCCESS = '@bulk-payment/APPROVE_BULK_PAYMENT_SUCCESS',
  APPROVE_BULK_PAYMENT_FAILURE = '@bulk-payment/APPROVE_BULK_PAYMENT_FAILURE',
  REJECT_BULK_PAYMENT_REQUEST = '@bulk-payment/REJECT_BULK_PAYMENT_REQUEST',
  REJECT_BULK_PAYMENT_SUCCESS = '@bulk-payment/REJECT_BULK_PAYMENT_SUCCESS',
  REJECT_BULK_PAYMENT_FAILURE = '@bulk-payment/REJECT_BULK_PAYMENT_FAILURE',
  BULK_PAYMENT_CHECK_REQUEST = '@bulk-payment/BULK_PAYMENT_CHECK_REQUEST',
  BULK_PAYMENT_CHECK_SUCCESS = '@bulk-payment/BULK_PAYMENT_CHECK_SUCCESS',
  BULK_PAYMENT_CHECK_FAILURE = '@bulk-payment/BULK_PAYMENT_CHECK_FAILURE',
  DOWNLOAD_SAMPLE_FILE_REQUEST = '@bulk-payment/DOWNLOAD_SAMPLE_FILE_REQUEST',
  DOWNLOAD_SAMPLE_FILE_SUCCESS = '@bulk-payment/DOWNLOAD_SAMPLE_FILE_SUCCESS',
  DOWNLOAD_SAMPLE_FILE_FAILURE = '@bulk-payment/DOWNLOAD_SAMPLE_FILE_FAILURE',
  BULK_PAYMENT_EXPORT_REQUEST = '@bulk-payment/BULK_PAYMENT_EXPORT_REQUEST',
  BULK_PAYMENT_EXPORT_SUCCESS = '@bulk-payment/BULK_PAYMENT_EXPORT_SUCCESS',
  BULK_PAYMENT_EXPORT_FAILURE = '@bulk-payment/BULK_PAYMENT_EXPORT_FAILURE',
  CLEAR_BULK_PAYMENT_STATES = '@bulk-payment/CLEAR_BULK_PAYMENT_STATES',
}

export interface BulkPaymentApprovalPayload {
  fileId: number;
  email: string;
  otp: string;
}

export interface BulkPaymentRejectPayload {
  fileId: number;
  email: string;
  otp: string;
}

export interface BulkPaymentCheckPayload {
  fileId: number;
  email: string;
  otp: string;
}

export interface BulkPaymentCheckItem {
  id: number;
  fileId: number;
  msisdn: string;
  providerName: string | null;
  currency: string;
  amount: number;
  statusId: number;
  paymentDate: string;
  channel: string;
}

export interface BulkPaymentExportPayload {
  fileId: number;
  email: string;
  otp: string;
}

export interface BulkPaymentFilesPayload {
  pageSize: number;
  skip: number;
}

export interface BulkPaymentFilesResponse {
  files: PaymentFile[];
  total: number;
}

export type BulkPaymentState = {
  readonly pages: FilePreview[];
  readonly processing: boolean;
  readonly loading: boolean;
  readonly isSubmitting: boolean;
  readonly error: any;
  readonly success: boolean;
  readonly uploaded: boolean;
  readonly files: PaymentFile[];
  readonly filesTotal: number;
  readonly failed: boolean;
  readonly failure: boolean;
  readonly step: number;
  readonly fileId: number;
  readonly filePreviewSuccess: boolean;
  readonly providerName: string;
  readonly providers: Providers[];
  readonly bulkpay: null;
  readonly loadingFiles: boolean;
  readonly uploadingFile: boolean;
  readonly uploadSuccess: boolean;
  readonly isApproving: boolean;
  readonly approvalError: any;
  readonly approvalSuccess: boolean;
  readonly isRejecting: boolean;
  readonly rejectError: any;
  readonly rejectSuccess: boolean;
  readonly checkResult: BulkPaymentCheckItem[];
  readonly checkLoading: boolean;
  readonly checkError: any;
  readonly downloadingSampleFile: boolean;
  readonly downloadSampleFileError: any;
  readonly submitToCheckerError: any;
  readonly submitToCheckerSuccess: boolean;
  readonly isExporting: boolean;
  readonly exportError: any;
};
